module.exports = __webpack_public_path__ + "Flaticon.81092962aff959814780.svg";


//////////////////
// WEBPACK FOOTER
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/fonts/Flaticon.svg
// module id = ../../../../../src/fonts/Flaticon.svg
// module chunks = styles